import React, { useState, useEffect } from "react";
import _ from 'lodash';
import moment from "moment";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactEcharts from 'echarts-for-react';
import * as echarts from 'echarts'
import { withStyles, makeStyles } from '@material-ui/core/styles';
import ChartStyle from 'styles/ChartStyle';
import { chartLineWidth } from 'styles/variables';
import Label from 'utils/Label';
import ChartConfig from 'utils/ChartConfig';
import * as H from 'helper';
import * as V from 'styles/variables';

const useStyles = makeStyles((theme) => ({
    chartContainer: {
        marginTop: 16,
        marginLeft: 16,
        width: '100%',
        display: 'block'
    }
}));

const LineChartNftOwnTrend = ({
    legend,
    lblSaveImage,
    seriesData,
    chartType,
}) => {
    const classes = useStyles();
    const [seriesType, setSeriesType] = useState(chartType);
    const [xAisData, setXAisData] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [color, setColorArray] = useState([]);
    const [stackState, setStackState] = useState('');
    const [zoomStart, setZoomStart] = useState(0);
    const [zoomEnd, setZoomEnd] = useState(100);

    useEffect(() => {
        echarts.registerTheme('BarChartTheme', ChartStyle);
    }, []);

    useEffect(() => {
        let eachChartSeries = {}, seriesDataArray = [], xAxisDataArray = [], colorArray = [],
        nftOwnCount = [], nftOwnPmidUnique = [], priceTotalArray = [];
        _.forOwn(seriesData[0]['total'], function(data, index) {
            xAxisDataArray.push(data['date']);
            nftOwnCount.push(data['count']);
            // let chartType = value.id;
            // colorArray.push(ChartConfig.chartColorByType[value.id]);
            // _.forOwn(value, function(value2, key2) {
            //     if (key2 === 'data') {
            //         eachChartSeries.name = Label.chartSeriesName[chartType];
            //         eachChartSeries.type = value.id.indexOf("-amount") !== -1 ? "bar" : "line";
            //         if (value.id.indexOf("-amount") !== -1) {
            //             eachChartSeries.yAxisIndex =  1;
            //         }
            //         eachChartSeries.data = value2;
            //         eachChartSeries.lineStyle = {width: chartLineWidth};
            //         eachChartSeries.symbolSize = seriesData[0]['date'].length > 60 ? 4 : 8;
            //         eachChartSeries.barGap = 0;
            //         eachChartSeries.barMaxWidth = 20;
            //         seriesDataArray.push(eachChartSeries);
            //         eachChartSeries = {};
            //     }
            // });
        });

        _.forOwn(seriesData[0]['unique'], function(data2, index) {
            nftOwnPmidUnique.push(data2['count']);
        });

        _.forOwn(seriesData[0]['price'], function(data3, index) {
            priceTotalArray.push(data3['price']);
        });

        // set all chart data
        colorArray = [V.genericColorPallette[0], V.genericColorPallette[1], V.genericColorPallette[2]]
        seriesDataArray = [
            {
                barGap: 0,
                barMaxWidth: 20,
                data: nftOwnCount,
                lineStyle: {width: 4},
                name: "ユーザー保有NFT数",
                symbolSize: 8,
                type: "line"
            },
            {
                barGap: 0,
                barMaxWidth: 20,
                data: nftOwnPmidUnique,
                lineStyle: {width: 4},
                name: "NFTホルダーPMID",
                symbolSize: 8,
                type: "line"
            },
            // {
            //     barGap: 0,
            //     barMaxWidth: 20,
            //     data: priceTotalArray,
            //     lineStyle: {width: 4},
            //     name: "DEP総額",
            //     symbolSize: 8,
            //     type: "bar"
            // }
        ];
        setXAisData(xAxisDataArray);
        setChartData(seriesDataArray);
        setColorArray(colorArray);
    }, [seriesData, seriesType]);

    const magicTypeChanged = (param) => {
        if (param.currentType === 'stack') {
            setStackState('__ec_magicType_stack__');
        } else if (param.currentType === 'tiled') {
            setStackState(null);
        } else {
            setSeriesType(param.currentType);
        }
    }

    const dataZoomChanged = (param) => {
        setZoomStart(param.batch[0]['start']);
        setZoomEnd(param.batch[0]['end']);
    }

    const onEvents = {
        'magictypechanged': magicTypeChanged,
        'datazoom': dataZoomChanged,
    }

    return (
        <div className={classes.chartContainer}>
            <ReactEcharts
                option={{
                    tooltip: {
                        trigger: "axis",
                        axisPointer : {
                            type : 'none'
                        },
                        //order:'valueDesc',
                    },
                    grid: {
                        left: 64,
                        top: 48,
                        right: 48,
                        bottom: 32
                    },
                    legend: {
                        show: true,
                        data: legend
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            magicType : {
                                show: false,
                                type: ['bar', 'line'],
                                title: {
                                    line: "Line",
                                    bar: "Bar",
                                    stack: "Stack",
                                    tiled: "Side by Side",
                                },
                                icon: {
                                    line: 'image://../../static/images/font-icon/line-chart.svg',
                                    bar: 'image://../../static/images/font-icon/bar-chart.svg',
                                }
                            },
                            saveAsImage: {
                                show: false,
                                title: "Save",
                                name: lblSaveImage,
                                icon: 'image://../../static/images/font-icon/save-chart.svg'
                            },
                        }
                    },
                    xAxis: {
                        type: "category",
                        data: xAisData
                    },
                    yAxis: [
                        {
                            type: "value",
                            name: '件数',
                            minInterval: 1,
                            // axisLabel: {
                            //     formatter: '{value} 件'
                            // }
                        },
                        // {
                        //     type: "value",
                        //     name: 'DEP',
                        //     axisLabel: {
                        //         formatter: function (value, index) {
                        //             return H.FormatNumStrHelper.formatKandM(value);
                        //         }
                        //     }
                        // },
                    ],
                    dataZoom: [
                        {
                            disabled: true,
                            type: 'inside',
                            start: zoomStart,
                            end: zoomEnd
                        },
                    ],
                    series: chartData,
                    color: color,
                }}
                theme='BarChartTheme'
                notMerge={true}
                lazyUpdate={true}
                onEvents={onEvents}
                style={{height: '350px', width: '98%'}}
            />
        </div>
    );
};

LineChartNftOwnTrend.propTypes = {
    classes: PropTypes.object,
};

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(null, { withTheme: true })(LineChartNftOwnTrend));
